import * as React from "react"
import { AppTableSeeker } from "@components"

import {alertNameColumn, dateColumn, imageSkuColumn, priceColumn, retailerColumn, skuColumn, diffColumn, notificationColumn} from "./columns"
import RepricingTableTitle from "./title"


export default function RepricingTable({ data, title, columns={}, numScope, updated, same, increase, decrease, myPriceName='Current Price' }) {
    return <AppTableSeeker
		title={<RepricingTableTitle title={title} numScope={numScope} updated={updated} same={same} decrease={increase} increase={decrease} />}
		data={data}
		columns={[
			...columns?.imageSku ? [imageSkuColumn()] : [],
			...columns?.sku ? [skuColumn()] : [],
			...columns?.alertName ? [alertNameColumn()] : [],
			...columns?.myPrice ? [priceColumn('myPrice', myPriceName)] : [],
			...columns?.newPrice ? [priceColumn('newPrice', 'Reprice', true)] : [],
			...columns?.diffPrice ? [diffColumn()] : [],
			...columns?.date ? [dateColumn()] : [],
			...columns?.notification ? [notificationColumn()] : [],
			...columns?.retailer ? [retailerColumn()] : [],
		]}
		options={{
			print: false,
			filter: false,
			viewColumns: false
		}}
	/>
}